module.exports = __webpack_public_path__ + "static/user-testing-webinar@2x-4ee2dbc10dc29fbfec63f2924bf05de8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/user-testing-webinar@2x.png
// module id = 2701
// module chunks = 157636680307020